<div *ngIf="isTreeComponentLoading" class="sp-spinner" style="height: 200px;display: flex;align-items: center;justify-content: center;">
  <mat-spinner [mode]="'indeterminate'" strokeWidth="3" style="margin:0 auto;width: 50px;height: 50px;"></mat-spinner>
</div>

<div *ngIf="!isTreeComponentLoading">
  <!-- The left column with root elements buttons has been removed -->
  <div class="flex-grow-1" (scroll)="onScroll($event)" #treeScrollContainer style="height: 200px; overflow-y: auto; max-height: 200px;padding-right: 14px;">
    
    <!-- Only show these when not loading -->
    <ng-container>
      <div *ngIf="hasNoSearchResults" class="text-center">
        <mat-icon class="color-black-400 text-3xl w-32 h-32">search_off</mat-icon>
        <p class="color-black-600 text-base mt-12">No results found for your search.</p>
      </div>
      
      <!-- Tree with results -->
      <mat-tree *ngIf="!hasNoSearchResults" [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- Parent node template -->
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" 
                      [ngClass]="{'bg-color-black-100': treeControl.isExpanded(node)}" 
                      class="py-10 gap-10 mb-8 border-radius-8 bg-color-black-100-on-hover cursor-pointer" 
                      matTreeNodeToggle
                      [style.padding-left.px]="10">
          <mat-icon [attr.aria-label]="'Toggle ' + node.item" class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
          <span class="color-black-700 font-medium text-sm2" style="cursor: pointer;">{{ node.name }}</span>
          <mat-spinner *ngIf="node.isLoading" [mode]="'indeterminate'" strokeWidth="6" style="margin-left:8px;width: 20px;height: 20px;"></mat-spinner>
        </mat-tree-node>
        
        <!-- Child node template -->
        <mat-tree-node (click)="onNodeClick(node)"  
                      *matTreeNodeDef="let node" 
                      class="py-10 pr-24 mb-8 border-radius-8" 
                      [style.padding-left.px]="56"
                      [ngClass]="isSelected(node) ? 'bg-color-orange-100' : 'bg-color-white-900 bg-color-black-100-on-hover bg-color-orange-400-on-pressed color-orange-600-on-pressed cursor-pointer'">
          <div class="flex flex-col">
            <span class="font-medium text-sm2" [ngClass]="isSelected(node) ? 'color-orange-600' : 'color-black-700'">
              {{ node.name }}
            </span>
            <span *ngIf="node.created_at" class="text-xs color-black-400">
              Created: {{ node.created_at | date:'mediumDate' }}
            </span>
          </div>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: isLoadMore"
          role="treeitem" (click)="loadOnClick($event, node)"
          (keydown)="loadOnKeypress($event, node)"
          class="py-10 pr-24 mb-8 border-radius-8 bg-color-black-100-on-hover cursor-pointer"
          [style.padding-left.px]="56">
          <div class="flex items-center w-full">
            <span class="color-orange-600 font-medium text-sm2">Load more elements</span>
            <mat-spinner *ngIf="node.isLoading" [mode]="'indeterminate'" strokeWidth="6" style="margin-left:8px;width: 20px;height: 20px;"></mat-spinner>
          </div>
        </mat-tree-node>
      </mat-tree>
      
      <!-- Loading more items indicator -->
      <div *ngIf="isLoadingMore" class="text-center py-12">
        <mat-spinner [mode]="'indeterminate'" strokeWidth="3" style="margin:0 auto;width: 30px;height: 30px;"></mat-spinner>
        <p class="color-black-600 text-sm mt-8">Loading more items...</p>
      </div>
    </ng-container>
  </div>
</div>



